import React from 'react';
const ServicePlans = () => {
  const plans = [{
    id: 1,
    title: 'One-Year Service Plan',
    subtitle: '1 Appliance',
    price: '£99.00',
    description: 'Reliable cover for your appliance with 12 months of unlimited repairs, priority support, and expert engineer care.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/io3J31vqtBEKHp6mysvXvN/06._Dishawasher_.png',
    imageAlt: 'Technician repairing dishwasher',
    paymentLink: 'https://buy.stripe.com/6oU8wP0ro6Z209q5c1ao801'
  }, {
    id: 2,
    title: 'One-Year Service Plan',
    subtitle: 'TV + Set-Top Box',
    price: '£120.00',
    description: 'Protect your home entertainment with unlimited repairs and rapid-response service for your TV and set-top box.',
    image: 'https://images.unsplash.com/photo-1593784991095-a205069470b6?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    imageAlt: 'Family watching TV',
    paymentLink: 'https://buy.stripe.com/aFa28r1vsdnq1ducEtao800'
  }];
  return <section className="py-16 bg-gray-50" data-id="element-49">
      <div className="container mx-auto px-4" data-id="element-50">
        <div className="text-center mb-12" data-id="element-51">
          <h2 className="text-3xl font-bold text-[#0a3d62] mb-4" data-id="element-52">
            Our Service Plans
          </h2>
          <p className="max-w-2xl mx-auto text-gray-600" data-id="element-53">
            Choose the perfect service plan for your needs with our
            comprehensive coverage options. All plans include expert engineers
            and priority support.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-54">
          {plans.map(plan => <div key={plan.id} className="bg-white rounded-lg shadow-lg overflow-hidden flex flex-col h-full transition-transform hover:-translate-y-1" data-id="element-55">
              <div className="h-48 overflow-hidden" data-id="element-56">
                <img src={plan.image} alt={plan.imageAlt} className="w-full h-full object-cover transition-transform hover:scale-105" data-id="element-57" />
              </div>
              <div className="p-6 flex-grow" data-id="element-58">
                <div className="mb-4" data-id="element-59">
                  <h3 className="text-xl font-bold text-[#0a3d62]" data-id="element-60">
                    {plan.title}
                  </h3>
                  <p className="text-gray-500" data-id="element-61">{plan.subtitle}</p>
                </div>
                <p className="text-2xl font-bold text-[#3fc1c9] mb-4" data-id="element-62">
                  {plan.price}
                </p>
                <p className="text-gray-600 mb-6" data-id="element-63">{plan.description}</p>
              </div>
              <div className="px-6 pb-6" data-id="element-64">
                <a href={plan.paymentLink} className="block w-full bg-[#0a3d62] hover:bg-[#072f4a] text-white text-center font-medium py-3 px-4 rounded-md transition-colors" data-id="element-65">
                  Buy Now
                </a>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};
export default ServicePlans;